import serverApi from "../../utils/serverApi";

const partnerService = {
  getPartnerPermissions: (data) => serverApi({ uri: "partners/permissions", method: "GET", data }),
}

export default partnerService;
